import { ImageIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Image = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ImageIcon {...rest} size={Sizes[size]} color={fill} />;
};

Image.displayName = 'Image';
